import React  from 'react';
import { Button} from 'antd';
import { Header, Title } from '$app/shared/components/Header';
import { useMaiaT } from '$app/i18n/useMaiaT';
import { useGarageGaryAuthLink } from './hooks/useGarageGaryAuthLink';

export default function GaragePageHeader(props) {
  const t = useMaiaT();
  const { autoLoginLink, loading } = useGarageGaryAuthLink(props.garageId);

  function closePageHandler() {
    props.history.push('/');
  }
  return (
    <Header className="justify">
      <Title>
        {props?.name ? props?.name : t('maia.garageList.createGarage', 'Create garage')}
        <Button type="link" onClick={closePageHandler} className="pull-right">
          <img
            src="/assets/images/close-black.svg"
            style={{ cursor: 'pointer', height: 20 }}
            alt={t('maia.common.close', 'Close')}
          />
        </Button>
        {props.garageId && (
          <Button
            type="primary"
            href={autoLoginLink || undefined}
            target="_blank"
            rel="noreferrer"
            disabled={!autoLoginLink}
            loading={loading}
            className="pull-right"
          >
            {t('maia.garageInfo.openGary', 'Login as garage')}
          </Button>
        )}
      </Title>
    </Header>
  );
}
